import * as actions from '../actionTypes';
import loginActions from '../actionTypes/loginActions';
import { ROLES } from '../globalConstants';

const initialState = {};

const getRestaurantId = user => {
  return user && user.role === ROLES.restaurant_admin
    ? user.resourceable_id
    : null;
};

const currentRestaurant = (state = initialState, action) => {
  let user = null;
  switch (action.type) {
    case actions.SET_CURRENT_RESTAURANT:
      return action;
    case loginActions.setCurrentUser:
      user = action.payload;
      return {
        ...state,
        id: getRestaurantId(user)
      };
    case loginActions.userLoginSuccess:
      user = action.payload.data.attributes;
      return {
        ...state,
        id: getRestaurantId(user)
      };
    default:
      return state;
  }
};

export default currentRestaurant;
